import request from '@/utils/request'
// 获取农事类型选项
export function getFarmTypeOption() {
    return request({
      url: '/index/Production/getFarmTypeOption',
      method: 'get',
    })
  }
  //生产管理-农事操作 列表
  export function  farmActiontList(query) {
    return request({
      url: '/index/Production/farmActiontList',
      method: 'get',
      params: query
    })
  }
  //生产管理-农事操作-种植作物 列表
  export function  plantList(query) {
    return request({
      url: '/index/Production/plantList',
      method: 'get',
      params: query
    })
  }
  //生产管理-农事操作-种植作物 列表
  export function  plantFarmActionList(query) {
    return request({
      url: '/index/Production/plantFarmActionList',
      method: 'get',
      params: query
    })
  }
// 获取农事类型选项
export function  getTypeOption() {
    return request({
      url: '/index/Production/getTypeOption',
      method: 'get',
    })
  }
  //生产管理-农事操作-种植作物 列表
  export function  getGoodNameOption(query) {
    return request({
      url: '/index/Production/getGoodNameOption',
      method: 'get',
      params: query
    })
  }
  // 获取 品牌 选项
  export function  getBrandOption(query) {
    return request({
      url: '/index/Production/getBrandOption',
      method: 'get',
      params: query
    })
  }
  // 获取 生产企业 选项
  export function  getCompanyOption(query) {
    return request({
      url: '/index/Production/getCompanyOption',
      method: 'get',
      params: query
    })
  }
  // 新增（处理） 农事操作
  export function  addFarmActionInfo(data) {
    return request({
      url: '/index/Production/addFarmActionInfo',
      method: 'post',
      data
    })
  }
  // 根据日期获取数据 生产管理-农事操作 种植作物 待处理事项 列表-时间查询plantToDay
  export function  plantToDay(query) {
    return request({
      url: '/index/Production/plantToDay',
      method: 'get',
      params: query
    })
  }